import throttle from 'lodash/throttle';
import canUseDOM from 'exenv';

export default class {
  constructor(player) {
    this.data = {};
    this.player = player;
    this.scrollEvent = throttle(() => {
      this.autoplay(this.player);
    }, 300);
  }

  isInViewport(element) {
    if (element && element.getBoundingClientRect) {
      const rect = element.getBoundingClientRect();
      const html = document.documentElement;
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
      );
    }
    return false;
  }

  autoplay(iframe) {
    this.data.command = 'pause';
    if (this.isInViewport(iframe)) {
      this.data.command = 'play';
    }
    iframe.contentWindow.postMessage(this.data, '*');
  }

  on() {
    if (canUseDOM) {
      window.addEventListener('scroll', this.scrollEvent);
    }
  }

  off() {
    if (canUseDOM) {
      window.removeEventListener('scroll', this.scrollEvent);
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/post/utils/embed_autoplay.js